module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Bold-Alphabetic.201d3dbb.woff2";